<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container" >
      <div class="container-fluid">
        <div class="row">
          <div class="col-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-9">
            <div class="material-table-widget dashboard_top_bar">
              <button @click="CreateCategoryModal=true" class="btn btn-default btn-new"><i class="fa fa-plus"></i> 新增任務類型</button> 
            </div>
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>任務設定</h3>
                </div>
              </div>
              <div class="widget-container">
                <div class="widget-content">
                  <p class="alert alert-info">您可以在此自訂各種行事曆任務類型，之後建立行事曆內的代辦事項，可以選擇新的事項類型<br>業務的統計數據，也會顯示這些類型的資訊唷！</p>
                  <draggable class="dragArea full-width text-left product_drag_area" v-model="activity_categories" :options="dragOptions"  :move="getDraggedData" @change="onChange($event, null)">
                    <transition-group class="product_drag_area" type="transition" tag="div">
                      <div v-for="category in orderedCategories" class="row draggable_product" :key="category.order" v-bind:id="category.id">
                        <div class="col-xs-8">
                          <i v-bind:class="category.icon"></i> {{category.title}}
                        </div>
                        <div class="col-xs-4 text-right">
                          <a class="row-edit" @click="EditCategory(category)"><span class="zmdi zmdi-edit"></span></a>
                          <a class="row-edit" @click="DeleteCategoryModal = true;delete_category=category"><span class="zmdi zmdi-close"></span></a>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
    <!--Page Container End Here-->
    <!-- modal template start-->
    <div v-if="CreateCategoryModal" @keyup.esc="CreateCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="CreateCategoryModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                <h4>新增任務類型</h4>
              </div>
              <a href="#" class="btn-close" @click="CreateCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <div class="form-group j-forms">
                <label for="text">類型名稱*</label>
                <input class="form-control login-frm-input" type="text" placeholder="類型名稱*" name="title" v-model="temp_category.title" v-validate="'required:true'">
                <i v-show="errors.has('title')" class="fa fa-warning"></i>
                <span v-show="errors.has('title')" class="help is-danger">請輸入類型名稱</span>
              </div>
              <div class="form-group j-forms">
                <label for="text">任務Icon*：<i v-if="temp_category.icon!=''" v-bind:class="temp_category.icon"></i></label>
                <input ref="picker" v-model="search" @blur="blur" @focus="focus" name="icon" type="text" class="form-control"  placeholder="點擊來選擇icon，可用英文關鍵字過濾icon，ex: dinner"  v-validate="'required:true'">
                <i v-show="errors.has('icon')" class="fa fa-warning"></i>
                <span v-show="errors.has('icon')" class="help is-danger">請輸入選擇一個icon</span>
                <transition name="icon-preview-fade">
                  <div v-if="focusOn" class="preview-container">
                    <div @click="select(undefined)" @mouseover="hoverPanel = true" @mouseout="hoverPanel = false" :class="['previewer', 'rounded', {'custom-shadow-sm': !hoverPanel}, {'custom-shadow': hoverPanel} ]">
                      <div v-for="(i, index) in iconsFiltered" :key="index" class="icon-preview">
                        <div @click.prevent.stop="select(i)" :class="['icon-wrapper','rounded','shadow-sm', {selected: i.title == selected}]" >
                          <i :class="i.title" />
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="CreateCategory()">
                  建立
                </button>
                <button class="btn btn-default" @click="CreateCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="UpdateCategoryModal" @keyup.esc="UpdateCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="UpdateCategoryModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                <h4>編輯任務類型</h4>
              </div>
              <a href="#" class="btn-close" @click="UpdateCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <div class="form-group j-forms">
                <label for="text">類型名稱*</label>
                <input class="form-control login-frm-input" type="text" placeholder="類型名稱*" name="title" v-model="update_category.title" v-validate="'required:true'">
                <i v-show="errors.has('title')" class="fa fa-warning"></i>
                <span v-show="errors.has('title')" class="help is-danger">請輸入類型名稱</span>
              </div>
              <div class="form-group j-forms">
                <label for="text">任務Icon*：<i v-if="update_category.icon!=''" v-bind:class="update_category.icon"></i></label>
                <input ref="picker" v-model="search" @blur="blur" @focus="focus" name="icon" type="text" class="form-control"  placeholder="點擊來選擇icon，可用英文關鍵字過濾icon，ex: dinner"  v-validate="'required:true'">
                <i v-show="errors.has('icon')" class="fa fa-warning"></i>
                <span v-show="errors.has('icon')" class="help is-danger">請輸入選擇一個icon</span>
                <transition name="icon-preview-fade">
                  <div v-if="focusOn" class="preview-container">
                    <div @click="select(undefined)" @mouseover="hoverPanel = true" @mouseout="hoverPanel = false" :class="['previewer', 'rounded', {'custom-shadow-sm': !hoverPanel}, {'custom-shadow': hoverPanel} ]">
                      <div v-for="(i, index) in iconsFiltered" :key="index" class="icon-preview">
                        <div @click.prevent.stop="select(i)" :class="['icon-wrapper','rounded','shadow-sm', {selected: i.title == selected}]" >
                          <i :class="i.title" />
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateCategory()">
                  更新
                </button>
                <button class="btn btn-default" @click="UpdateCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="DeleteCategoryModal" @keyup.esc="DeleteCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="DeleteCategoryModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                <h4>你確定要刪除此類型？ <i v-bind:class="delete_category.icon"></i> {{delete_category.title}}</h4>
              </div>
              <a href="#" class="btn-close" @click="DeleteCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <p class="alert alert-info">刪除類型，並不會刪除該類型的所有待辦事項</p>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-danger" @click="DeleteCategory(delete_category)">
                  <i class="fa fa-times"></i> 確定刪除
                </button>
                <button class="btn btn-default" @click="DeleteCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import draggable from 'vuedraggable'
import iconsList from '../../assets/js/elffy_js/icons.js'

let timeout = undefined;

export default {
  name: 'activity_categories',
  components: {
    Simplert,smallBar,draggable
  },
  data() {
    return {
      activity_categories: [],
      focusOn: true, // <- set this to false
      icons: iconsList.icons,
      hoverPanel: false,
      search: "",
      beforeSelect: "",
      selected: "",
      value: "",
      refs: this.$refs,
      auth_token: '',
      CreateCategoryModal: false,
      UpdateCategoryModal: false,
      DeleteCategoryModal: false,
      dragged_data: '',
      temp_category: {
        title: '',
        icon: '',
        order: '',
      },
      update_category: {},
      delete_category: {},
    }
  },
  created() {
    this.GetCategories()
  },
  props: ['toggle_aside','user'],
  beforeMount(){
    this.search = this.value
  },
  watch: {
    search: function(newValue){
      this.$emit('input', newValue)
    }
  },
  mounted() {
    
  },
  computed: {
    orderedCategories: function () {
      //return this.products
      return _.orderBy(this.activity_categories, 'order')
    },
    iconsFiltered: function(){
      const search = (this.search == this.selected) ? this.beforeSelect : this.search
      return this.icons.filter(i => 
        i.title.indexOf(search) !== -1 || i.searchTerms.some(t => t.indexOf(search) !== -1)
      )
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'activity_category_box',
        ghostClass: 'ghost'
      }
    },
  },
  methods: {
    getDraggedData: function(event) {
      this.dragged_data = event
    },
    onChange: function(event,pc) {
      let vm=this
      if(event.moved){
        console.log('change')
        var pindex = 0
        var order = 0
        var newIndex = event.moved.newIndex
        var changed= event.moved.element
        //開始重置這個分類的順序
        this.orderedCategories.forEach(function(p,index){
          if(p != changed){
            //如果這個物件的位子，不是位於即將插入的物件的位子，則依序往下排
            if(newIndex == order){
            //如果這個物件卡到新的位子，就往下移動一個位子  
              order += 1
            }
            pindex =  vm.activity_categories.indexOf(p)
            p.order = order;
            vm.$set(vm.activity_categories, pindex, p);
            order += 1
          }else{
            pindex =  vm.activity_categories.indexOf(p)
            p.order = newIndex;
            vm.$set(vm.activity_categories, pindex, p);
          }
        })
        //重置結束
       vm.UpdateCategoriesOrder();
      }
    },
    blur(){
      timeout = setTimeout(() => {
        this.focusOn = false;
      }, 150);
    },
    focus(){
      this.focusOn = true;
    },
    select(icon){
      let vm = this
      clearTimeout(timeout)
      if(icon){
        if(this.search != this.selected) this.beforeSelect = this.search
        this.selected = icon.title;
        this.search = icon.title;
        if(this.CreateCategoryModal){
          vm.$set(this.temp_category,'icon',icon.title)
        }
        if(this.UpdateCategoryModal){
          vm.$set(this.update_category,'icon',icon.title)
        }
      }
      this.$refs.picker.focus()
    },
    GetCategories(){
      const vm = this;
      this.axios.get('activity_categories', {
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.activity_categories =  response['data']['data']
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    CreateCategory(){
      const vm = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.CreateCategoryModal = false
          vm.temp_category.order = vm.activity_categories.length
          vm.axios.post('activity_categories', {
            activity_category: vm.temp_category
          })
          .then(function(response) {
            if (response.status == 200) {
              vm.activity_categories =  response['data']['data']
              vm.temp_category.icon = ''
              vm.temp_category.title = ''
            } else {
              var obj = {
                isShown: true,
                title: '建立失敗、請稍後再試',
                message: '更新失敗',
                type: 'error',
                customCloseBtnText: '關閉'
              }
              vm.refs.simplert.openSimplert(obj);
            }
          })
          .catch(function(error) {
            console.log('error:', error)
          });
        } else {
          console.log('validate fail')
        }
      });
    },
    EditCategory(category){
      let vm = this
      this.$set(this.update_category,'title',category.title)
      this.$set(this.update_category,'id',category.id)
      this.$set(this.update_category,'icon',category.icon)
      this.UpdateCategoryModal = true
    },
    UpdateCategory(){
      this.UpdateCategoryModal = false
      let vm = this;
      vm.axios.put('activity_categories/'+vm.update_category.id, {
        activity_category: vm.update_category
      })
      .then(function(response) {
        if (response['data']['status'] == 'success') {
          $.each(vm.activity_categories, function(key,category){
            if(category.id == vm.update_category.id){
              category.title = vm.update_category.title
              category.icon = vm.update_category.icon
            }
          })
          vm.$set(vm.update_category,'title','')
          vm.$set(vm.update_category,'id','')
          vm.$set(vm.update_category,'icon','')
          vm.search = ''
        } else if (response['data']['status'] == 'fail') {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        var obj = {
          isShown: true,
          title: '更新失敗、請稍後再試',
          message: '更新失敗',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
    UpdateCategoriesOrder(){
      const vm = this;
      this.axios.put('activity_categories/update_order', {
        activity_categories: vm.activity_categories
      })
      .then(function(response) {
        if (response.status == 200) {
          
        } else {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        var obj = {
          isShown: true,
          title: '更新失敗、請稍後再試',
          message: '更新失敗',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
    DeleteCategory(category){
      const vm = this;
      this.axios.delete('activity_categories/'+category.id, {
        
      })
      .then(function(response) {
        if (response.status == 200) {
          vm.activity_categories
          var index = vm.activity_categories.indexOf(category)
          vm.activity_categories.splice(parseInt(index), 1)
          vm.DeleteCategoryModal = false
        } else {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        var obj = {
          isShown: true,
          title: '更新失敗、請稍後再試',
          message: '更新失敗',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
  },
}
</script>
 <style> 

  .icon-preview-fade-enter-active, .icon-preview-fade-leave-active {
  transition: opacity .25s;
}

.icon-preview-fade-enter, .icon-preview-fade-leave-to {
  opacity: 0;
}

.preview-container {
  width: 100%;
  position: relative;
  height:200px;
  overflow: scroll;
}

.previewer {
  position: absolute;
  width: 100%;
  min-height: 50px;
  max-height: 500px;
  overflow: auto;
  background: white;
  top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.icon-preview {
  width: 10%;
  padding-top: 10%;
  position: relative;
}
@media (max-width: 800px) {
  .icon-preview {
    width: 33%;
    padding-top: 33%;
  }
}
.icon-preview .icon-wrapper {
  position: absolute;
  height: 80%;
  width: 80%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: ease-in-out all .25s;
}
.icon-preview .icon-wrapper:hover, .icon-preview .icon-wrapper.selected {
  background: #42b883;
  color: #fbfbfb;
}
.icon-preview .icon-wrapper i {
  font-size: 2vw;
}
</style>


// WEBPACK FOOTER //
// ActivityCategories.vue?8ce35a7a